import { makeStyles } from "@mui/styles";

const useStyles: any = makeStyles(() => ({
  filterContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    width: "280px",
    flexShrink: 0,
    minHeight: 0,
    paddingRight: "16px"
  }
}));

export default useStyles;
